import { omit } from 'ramda';
import { postApi } from 'util/api';
import { FSPS, HTTP_STATUS_CODE_404 } from 'consts';
import {
  buildPalIfpCredentialIdentifierPayload,
  buildPalIfpPasswordResetPayload,
} from './mappers/palIfpCredential';

const baseURL = (fspId) => `/auth/${FSPS}/${fspId}/pal-ifp/credential`;

const stripCallbacks = omit(['onSuccess', 'onApiErrors']);

const getHttpStatus = (error) =>
  error?.status ?? error?.statusCode ?? error?.response?.status;

/**
 * Soft-miss for status-only: HTTP 404 means no credential/user for the
 * identifier. Resolve null so callAction treats it as success (no global
 * error snackbar). Enable / disable / reset-request keep normal errors.
 */
export const status = async ({ fspId, ...source }) => {
  try {
    return await postApi(
      `${baseURL(fspId)}/status`,
      buildPalIfpCredentialIdentifierPayload(stripCallbacks(source))
    );
  } catch (error) {
    if (getHttpStatus(error) === HTTP_STATUS_CODE_404) {
      return null;
    }
    throw error;
  }
};

export const disable = ({ fspId, ...source }) =>
  postApi(
    `${baseURL(fspId)}/disable`,
    buildPalIfpCredentialIdentifierPayload(stripCallbacks(source))
  );

export const enable = ({ fspId, ...source }) =>
  postApi(
    `${baseURL(fspId)}/enable`,
    buildPalIfpCredentialIdentifierPayload(stripCallbacks(source))
  );

export const resetRequest = ({ fspId, ...source }) =>
  postApi(
    `${baseURL(fspId)}/reset-request`,
    buildPalIfpPasswordResetPayload(stripCallbacks(source))
  );
